<!--
  This dialog will be used to add gift credits to doordash account.
-->
<template>
  <dialog-form
    class="add-service-account-gift-dialog"
    :show-dialog="isShowDialog"
    :is-disabled="status.isLoading || !status.isFetchedCredits"
    @open="dialogOpen"
    @cancel="hideDialog"
    @submit="onSubmit"
  >
    <template #title>
      Add Gift Credits
    </template>

    <div
      v-loading="status.isLoading"
      element-loading-custom-class="custom-spinner-class"
      element-loading-text="Loading gift credits..."
    >
      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Account Email: </label>
        <div class="col-sm-8">
          {{ form.email }}
        </div>
      </div>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Available Credits: </label>
        <div class="col-sm-8">
          ${{ status.credits }}
        </div>
      </div>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Gift Card Pin* </label>
        <div class="col-sm-8">
          <sanitized-input
            id="gift-code"
            v-model="form.code"
            placeholder="Enter Gift Card Pin"
            required
          />
        </div>
      </div>
    </div>
    <template #submit-button>
      Add
    </template>
  </dialog-form>
</template>

<script lang="ts">
import { reactive, PropType } from 'vue';
import util from '@/Utils/util';
import { useSwalDialog } from '@/use/swalDialog';
import { ServiceAccount } from '@/models/serviceAccount';
import { serviceAccountService } from '@/services/serviceAccount';

export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
    serviceAccount: {
      type: Object as PropType<ServiceAccount | null>,
      default: () => null,
    },
  },
  emits: ['submit', 'cancel'],
  setup: (props: any, context: any) => {
    const { emit } = context;

    const status = reactive({
      isLoading: false,
      isFetchedCredits: false,
      credits: 0,
    });
    const form = reactive({
      email: '',
      code: '',
    });

    const { showErrorPopupDialog } = useSwalDialog();

    const getCredits = async () => {
      status.isLoading = true;
      try {
        const res = await serviceAccountService.getServiceAccountGiftCredits(form.email);
        status.credits = Number((res / 100).toFixed(2));
        status.isFetchedCredits = true;
      } catch (error) {
        const errorText = util.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        status.isLoading = false;
      }
    };

    const dialogOpen = () => {
      status.isFetchedCredits = false;
      status.credits = 0;
      form.email = '';
      form.code = '';

      if (!props.serviceAccount) {
        return;
      }

      form.email = props.serviceAccount.email;
      getCredits();
    };

    const onSubmit = () => {
      emit('submit', form);
    };

    const hideDialog = () => {
      emit('cancel');
    };

    return {
      form,
      status,

      dialogOpen,
      onSubmit,
      hideDialog,
    };
  },
};
</script>

<style lang="scss">
.add-temporary-dialog {
  .el-dialog__title {
    color: #34b5b8 !important;
  }
}
</style>
